import { render, staticRenderFns } from "./monthlyChannel.vue?vue&type=template&id=038df253&scoped=true&"
import script from "./monthlyChannel.vue?vue&type=script&lang=js&"
export * from "./monthlyChannel.vue?vue&type=script&lang=js&"
import style1 from "./monthlyChannel.vue?vue&type=style&index=1&id=038df253&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038df253",
  null
  
)

export default component.exports